{
  "title": "Haywire (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "3rd-level enchantment (technomagic)",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "This spell plays havoc with electronic devices, making the use of such devices all but impossible. Each electronic device in a 10-foot-radius sphere centered on a point you choose within range is subject to random behavior while it remains within the area. A device not held by a creature is automatically affected. If an electronic device is held by a creature, that creature must succeed on a Wisdom saving throw or have the device affected by the spell.",
    "At the start of each of your turns, roll a d6 for each affected device to determine its behavior. Except where otherwise indicated, that behavior lasts until the start of your next turn while this spell is in effect.",
    "d6",
    "Effect",
    "1",
    "The device shuts down and must be restarted. Do not roll again for this device until it is restarted.",
    "2-4",
    "The device does not function.",
    "5",
    "The device experiences a power surge, causing an electric shock to the wielder (if any and one random creature within 5 feet of the device. Each affected creature must make a Dexterity saving throw against your spell save DC, taking 6d6 lightning damage on a failed save, or half as much damage on a successful one.",
    "6",
    "The device is usable as normal.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the radius of the sphere affected by the spell increases by 5 feet for each slot level above 3rd."
  ],
  "spellLists": ["arcane-trickster", "sorcerer", "warlock", "wizard"]
}
